import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles, CircularProgress, Button, Grid } from '@material-ui/core';
import {
    FHEReactSelect,
    FHEContainerForm,
    FHETextField,
    FHECheckbox,
    FHEItemText,
    FHEWeatherAutoComplete,
    FormEditButton,
    FormSaveButton
} from 'data/components';
import { Toastr, tools } from 'data/common';
import memoizeOne from 'memoize-one';
import selectors from '../selectors';

class FormHome extends PureComponent {
    static propTypes = {
        stepHomeForm: PropTypes.object,
        classes: PropTypes.object.isRequired,
        sendDataFunc: PropTypes.func.isRequired,
        home: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
        searchCityUrl: PropTypes.string.isRequired,
        homeId: PropTypes.string,
        profile: PropTypes.object.isRequired,
        installers: PropTypes.object.isRequired
    };

    static defaultProps = {
        stepHomeForm: null,
        homeId: null
    };

    constructor(props) {
        super(props);
        const { type } = props;
        this.state = {
            formDisabled: type === 'update',
            homeForm: this.getDataForm(),
            textInput_error: {},
            sendLoading: false
        };
        this.orientations = [
            { value: 'SE', label: Translator.translate('general.orientation.SE') },
            { value: 'SSE', label: Translator.translate('general.orientation.SSE') },
            { value: 'S', label: Translator.translate('general.orientation.S') },
            { value: 'SSO', label: Translator.translate('general.orientation.SSO') },
            { value: 'SO', label: Translator.translate('general.orientation.SO') },
            { value: 'OSO', label: Translator.translate('general.orientation.OSO') },
            { value: 'O', label: Translator.translate('general.orientation.O') },
            { value: 'ONO', label: Translator.translate('general.orientation.ONO') },
            { value: 'NO', label: Translator.translate('general.orientation.NO') },
            { value: 'NNO', label: Translator.translate('general.orientation.NNO') },
            { value: 'N', label: Translator.translate('general.orientation.N') },
            { value: 'NNE', label: Translator.translate('general.orientation.NNE') },
            { value: 'NE', label: Translator.translate('general.orientation.NE') },
            { value: 'ENE', label: Translator.translate('general.orientation.ENE') },
            { value: 'E', label: Translator.translate('general.orientation.E') },
            { value: 'ESE', label: Translator.translate('general.orientation.ESE') }
        ];
        this.densities = [
            { value: 'montain', label: Translator.translate('general.density.montain') },
            { value: 'rural', label: Translator.translate('general.density.rural') },
            { value: 'urban', label: Translator.translate('general.density.urban') },
            { value: 'industrial', label: Translator.translate('general.density.industrial') }
        ];
        this.moduleTypes = [
            { value: 'low-ventilated', label: Translator.translate('general.moduleType.low-ventilated') },
            { value: 'ventilated', label: Translator.translate('general.moduleType.ventilated') },
            { value: 'well-ventilated', label: Translator.translate('general.moduleType.well-ventilated') }
        ];
        this.meters = [
            { value: 3000, label: '3' },
            { value: 6000, label: '6' },
            { value: 9000, label: '9' },
            { value: 12000, label: '12' },
            { value: 15000, label: '15' },
            { value: 18000, label: '18' }
        ];
        this.pitches = [
            { value: 0, label: '0' },
            { value: 5, label: '5' },
            { value: 10, label: '10' },
            { value: 15, label: '15' },
            { value: 20, label: '20' },
            { value: 25, label: '25' },
            { value: 30, label: '30' },
            { value: 35, label: '35' },
            { value: 40, label: '40' },
            { value: 45, label: '45' },
            { value: 50, label: '50' },
            { value: 55, label: '55' },
            { value: 60, label: '60' },
            { value: 65, label: '65' },
            { value: 70, label: '70' },
            { value: 75, label: '75' },
            { value: 80, label: '80' },
            { value: 85, label: '85' },
            { value: 90, label: '90' }
        ];
    }

    getDataForm = () => {
        const { home, type, stepHomeForm } = this.props;
        return {
            label: stepHomeForm ? stepHomeForm.label : type === 'update' ? home.get('label') : null,
            address: type === 'update' ? home.get('address') : null,
            city: type === 'update' ? home.get('city') : null,
            postalCode: type === 'update' ? home.get('postalCode') : null,
            isThreephase: type === 'update' ? home.get('isThreephase') : false,
            jpme: type === 'update' ? home.get('jpme') : false,
            homeState: type === 'update' ? home.get('homeState') : null,
            weatherCity: type === 'update' ? home.get('weatherCity') : null,
            meter: type === 'update' ? home.get('meter') : null,
            kWhPrice: type === 'update' ? home.get('kWhPrice') : null,
            generator: type === 'update' ? home.get('generator') : null,
            orientation: type === 'update' ? home.get('orientation') : null,
            roofPitch: type === 'update' ? home.get('roofPitch') : null,
            constructionDensity: type === 'update' ? home.get('constructionDensity') : null,
            moduleType: type === 'update' ? home.get('moduleType') : null,
            altitude: type === 'update' ? home.get('altitude') : null,
            latitude: type === 'update' ? home.get('latitude') : null,
            longitude: type === 'update' ? home.get('longitude') : null,
            boxMac: stepHomeForm ? stepHomeForm.boxMac : null,
            installerId: null
        };
    };

    loadInputs = () => {
        const { type } = this.props;

        this.setState({
            formDisabled: type === 'update',
            homeForm: this.getDataForm()
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    formatForm = () => {
        const { homeForm } = this.state;

        let form = homeForm;
        Object.keys(form).forEach(key => {
            if (form[key] === '') {
                form[key] = null;
            }
        });
        this.setState({
            homeForm: form
        });
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    getInstallersList = () => {
        const { installers } = this.props;

        let array = [
            {
                value: '',
                label: ''
            }
        ];
        installers.map((installer, installerId) =>
            array.push({
                value: installerId,
                label: installer.get('company')
            })
        );

        return array;
    };

    saveHome = () => {
        const { homeForm } = this.state;
        const { sendDataFunc } = this.props;

        this.formatForm();

        if (this.validateForm(homeForm)) {
            this.setState({
                formDisabled: true,
                sendLoading: true
            });
            return sendDataFunc(homeForm).catch(error => {
                Toastr.error(Translator.translate('generic.home.actions.addHomeError', homeForm.label));
                this.setState({
                    formDisabled: false,
                    sendLoading: false
                });
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(error.validation.errors, Translator.translate('generic.home.actions.addHomeError', homeForm.label));
                }
            });
        }
    };

    confirmEdit = () => {
        const { homeForm } = this.state;
        const { sendDataFunc, homeId } = this.props;

        this.formatForm();

        if (this.validateForm(homeForm)) {
            this.setState({
                sendLoading: true
            });
            return sendDataFunc(homeId, homeForm)
                .then(() => {
                    Toastr.success(Translator.translate('generic.home.actions.editHomeSuccess', homeForm.label));
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        sendLoading: false
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false
                    });
                    Toastr.error(
                        Translator.translateWithFallback(`api.message.${error.message}`, 'generic.home.actions.editHomeError', homeForm.label)
                    );
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate('generic.home.actions.editHomeError', homeForm.label)
                        );
                    }
                });
        }
    };

    handleEdit = () => {
        const { formDisabled } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabled: !formDisabled,
            textInput_error: {}
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    handleFormData = (field, value) => {
        const { homeForm } = this.state;
        if (field === 'boxMac') value = value.replace(/:/g, '');
        this.setState({
            homeForm: { ...homeForm, [field]: value }
        });
    };

    handleChange = event => {
        const { homeForm, textInput_error } = this.state;
        if (!event.target) return;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        const fieldLengthRules = {
            label: 80,
            address: 500,
            city: 255,
            postalCode: 5,
            apNum: 10
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = homeForm[event.target.name];
        if (event.target.pattern === 'd+') {
            targetValue = parseInt(targetValue.replace(/\D/g, ''));
            if (event.target.name === 'generator') targetValue = targetValue * 1000;
        } else if (event.target.type === 'number') {
            targetValue = parseFloat(targetValue);
        }

        this.setState({
            homeForm: { ...homeForm, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    validateForm = form => {
        const errors = {};
        const error = Translator.translate('general.fields.error.any.empty');
        const fields = [
            'label',
            'address',
            'city',
            'postalCode',
            'meter',
            'kWhPrice',
            'generator',
            'orientation',
            'roofPitch',
            'constructionDensity',
            'moduleType',
            'altitude',
            'latitude',
            'longitude'
        ];

        fields.forEach(field => {
            if (this.isEmpty(form[field])) {
                errors[field] = error;
            }
        });

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    handleChangeReactSelect = selectedOption => {
        const { homeForm } = this.state;
        this.setState({
            selectedOption,
            homeForm: { ...homeForm, installerId: parseInt(selectedOption.value) }
        });
    };

    renderButtonsForm = () => {
        const { formDisabled, sendLoading } = this.state;
        const { profile, type } = this.props;
        const userRights = profile.getIn(['user_rights', 'fhe'], []);
        if (type === 'update') {
            if (profile.get('admin') || userRights.includes('homeDetailsUpdate'))
                return (
                    <FormEditButton
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                    />
                );
        } else return <FormSaveButton sendFunc={this.saveHome} sendLoading={sendLoading} />;
    };

    getSelectedPitch = memoizeOne(pitch => {
        return this.pitches.find(x => x.value === pitch);
    });

    getSelectedMeter = memoizeOne(meter => {
        return this.meters.find(x => x.value === meter);
    });

    getSelectedModuleType = memoizeOne(moduleType => {
        return this.moduleTypes.find(x => x.value === moduleType);
    });

    getSelectedOrientation = memoizeOne(orientation => {
        return this.orientations.find(x => x.value === orientation);
    });

    getSelectedDensity = memoizeOne(density => {
        return this.densities.find(x => x.value === density);
    });

    handleReactSelect = (event, options) => {
        const { homeForm, textInput_error } = this.state;

        const newTextInput_error = tools.removeKey(textInput_error, options.name);

        this.setState({
            homeForm: { ...homeForm, [options.name]: event.value },
            textInput_error: newTextInput_error
        });
    };

    render() {
        const { loading, error, textInput_error, formDisabled, homeForm, selectedOption } = this.state;
        const { classes, type, searchCityUrl } = this.props;
        if (error) {
            return (
                <div className={classes.loadingContainer}>
                    <div className={classes.loadingContainer}>{error}</div>
                    <Button variant="contained" color="primary" className={classes.button} onClick={this.retryGetData}>
                        {Translator.translate('general.button.retry')}
                    </Button>
                </div>
            );
        }
        if (loading) {
            return (
                <div className={classes.loadingContainer}>
                    <CircularProgress />
                </div>
            );
        }
        return (
            <Fragment>
                {this.renderButtonsForm()}

                <FHEContainerForm>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="label"
                                value={!homeForm.label || homeForm.label === null ? '' : homeForm.label}
                                error={textInput_error.label}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="meter"
                                label={Translator.translate('general.table.column.meter')}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedMeter(homeForm.meter)}
                                choices={this.meters}
                                disabled={formDisabled}
                                error={textInput_error.meter}
                                suffix="kVa"
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="kWhPrice"
                                type="number"
                                value={!homeForm.kWhPrice || homeForm.kWhPrice === null ? '0.17' : homeForm.kWhPrice}
                                error={textInput_error.kWhPrice}
                                label={Translator.translate('general.table.column.kWhPrice')}
                                name="kWhPrice"
                                onChange={this.handleChange}
                                suffix="€"
                            />
                        </Grid>
                        {type === 'update' && (
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.homeState')}
                                    itemContent={
                                        !homeForm.homeState || homeForm.homeState === null
                                            ? ''
                                            : Translator.translate(`general.home-${homeForm.homeState}`)
                                    }
                                />
                            </Grid>
                        )}
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHECheckbox
                                checked={!!homeForm.isThreephase}
                                label={Translator.translate('general.table.column.isThreephase')}
                                value="isThreephase"
                                disabled={formDisabled}
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHECheckbox
                                checked={!!homeForm.jpme}
                                label={Translator.translate('general.table.column.jpme')}
                                value="jpme"
                                disabled={formDisabled}
                                onChange={this.handleChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="address"
                                value={!homeForm.address || homeForm.address === null ? '' : homeForm.address}
                                error={textInput_error.address}
                                label={Translator.translate('general.table.column.address')}
                                name="address"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="city"
                                value={!homeForm.city || homeForm.city === null ? '' : homeForm.city}
                                error={textInput_error.city}
                                label={Translator.translate('general.table.column.city')}
                                name="city"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="postalCode"
                                value={!homeForm.postalCode || homeForm.postalCode === null ? '' : homeForm.postalCode}
                                error={textInput_error.postalCode}
                                label={Translator.translate('general.table.column.postalCode')}
                                name="postalCode"
                                onChange={this.handleChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="generator"
                                value={!homeForm.generator || homeForm.generator === null ? '' : parseInt(homeForm.generator)}
                                error={textInput_error.generator}
                                label={Translator.translate('general.table.column.generator')}
                                name="generator"
                                type="number"
                                onChange={this.handleChange}
                                inputProps={{ pattern: 'd+', step: 1 }}
                                suffix="WC"
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="orientation"
                                label={Translator.translate('general.table.column.orientation')}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedOrientation(homeForm.orientation)}
                                choices={this.orientations}
                                error={textInput_error.orientation}
                                disabled={formDisabled}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="roofPitch"
                                label={Translator.translate('general.table.column.roofPitch')}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedPitch(homeForm.roofPitch)}
                                choices={this.pitches}
                                disabled={formDisabled}
                                error={textInput_error.roofPitch}
                                suffix="°"
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="constructionDensity"
                                label={Translator.translate('general.table.column.constructionDensity')}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedDensity(homeForm.constructionDensity)}
                                choices={this.densities}
                                error={textInput_error.constructionDensity}
                                disabled={formDisabled}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="moduleType"
                                label={Translator.translate('general.table.column.moduleType')}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedModuleType(homeForm.moduleType)}
                                choices={this.moduleTypes}
                                error={textInput_error.moduleType}
                                disabled={formDisabled}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="altitude"
                                type="number"
                                inputProps={{ pattern: 'd+' }}
                                value={!homeForm.altitude || homeForm.altitude === null ? '' : homeForm.altitude}
                                error={textInput_error.altitude}
                                label={Translator.translate('general.table.column.altitude')}
                                name="altitude"
                                onChange={this.handleChange}
                                suffix="m"
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="latitude"
                                type="number"
                                value={!homeForm.latitude || homeForm.latitude === null ? '' : homeForm.latitude}
                                error={textInput_error.latitude}
                                label={Translator.translate('general.table.column.latitude')}
                                name="latitude"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="longitude"
                                type="number"
                                value={!homeForm.longitude || homeForm.longitude === null ? '' : homeForm.longitude}
                                error={textInput_error.longitude}
                                label={Translator.translate('general.table.column.longitude')}
                                name="longitude"
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEWeatherAutoComplete
                                disabled={formDisabled}
                                id="weatherCity"
                                baseValue={homeForm.weatherCity === null ? '' : homeForm.weatherCity}
                                error={textInput_error.weatherCity}
                                label={Translator.translate('general.table.column.weatherCity')}
                                name="weatherCity"
                                query={searchCityUrl}
                                selectMeteo={this.handleFormData}
                            />
                        </Grid>
                        {type === 'add' && (
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEReactSelect
                                    closeMenuOnSelect
                                    label={Translator.translate('general.installer')}
                                    placeholder=""
                                    disabled={formDisabled}
                                    searchable
                                    onChange={this.handleChangeReactSelect}
                                    value={selectedOption}
                                    choices={this.getInstallersList()}
                                />
                            </Grid>
                        )}
                    </Grid>
                </FHEContainerForm>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const homeId = props.match.params.homeId;
    return {
        homeId,
        profile: selectors.getProfile(state),
        home: selectors.getHomeByHomeId(state, homeId),
        installers: selectors.getInstallers(state),
        prefixFheCenter: selectors.getPrefixFheCenter(state),
        searchCityUrl: selectors.getSearchCityUrl(state)
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(FormHome)));



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/forms/FormHome.js